/**
 * 关于融资专家接口对接调整
 * 所有地址为/center/*.jhtml的接口均需要签名
 * 签名说明：
 * 1.将参数按ASCII码排序，组装成key1=value1&key2=value2...keyn=valuen的字符串
 * 2.将组装好的参数字符串后拼接上签名token--登录或注册返回的mac参数
 * 3.将拼接好的字符串按MD5 32位小写加密
 * 4.将加密后的数据使用sign参数传递给接口
 * @author 杨海龙
 * @date 2017-07-26
 */

/**
 * 将参数组装成签名字符串
 * @param {Object} obj 参数对象
 * @param {Object} encode 是否对参数值进行编码 true--是 false--否
 */
function getLinkString (obj, encode) {
  // 去除对象中不参与加密的属性
  let keys = []
  for (let prop in obj) {
    if (prop === 'st' || prop === 'sv' || prop === 'pt' || prop === 'vs' || prop === 'sr' || prop === 'sign') {
      continue
    }
    // 如果是 null 或者 undefined 去掉
    if (obj[prop] == null) {
      continue
    }
    // 如果是 空格 或者 空字符 去掉
    if ((typeof obj[prop] === 'string') && obj[prop].trim().length === 0) {
      continue
    }
    // 把符合条件的参数存入数组
    keys.push(prop)
  }
  keys.sort() // 对参数进行排序
  let link = ''
  // 对排序后的参数进行拼接
  keys.forEach(function (prop, index) {
    let value = obj[prop]
    // 对参数进行UTF-8编码
    if (encode) {
      value = encodeURI(value)
    }
    link += prop + '=' + value + '&'
  })
  return link.replace(/[&]$/, '')
}

export default getLinkString

// 事例
// var param = new Object
// param.vs = '1.0.0'
// param.name = 'zs'
// param.age = 18
// param.sex = '男'
// param.password = 'asdfwrwe'
// param.phone = '54646456'
// param.mobile = '     '
// param.mobileCode = ''
// param.verifyCode = undefined
// param.paw = null
// var link = getLinkString(param, false)
// console.info(link) // age=18&name=zs&password=asdfwrwe&phone=54646456&sex=男



// WEBPACK FOOTER //
// ./src/util/sign.js